module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mb-4 p-sm-3 col-md-8"
  }, [_c('h1', [_vm._v(_vm._s(_vm.eventKindText) + "登録確認画面")]), _vm._v(" "), _c('p', [_vm._v("登録内容をご確認下さい。内容にお間違えがなければ、新規" + _vm._s(_vm.eventKindText) + "開催申請ボタンを押して下さい")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "mb-5 bg-faded p-4",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_vm._t("default", null, {
    item: _vm.eventForm,
    endDate: _vm.endDate,
    fullAddress: _vm.fullAddress
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "group"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-outline-info btn-lg",
    attrs: {
      "to": _vm.inputPath
    }
  }, [_vm._v("修正する")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.isDisabled
    }
  }, [_vm._v("新規" + _vm._s(_vm.eventKindText) + "開催申請")])], 1), _vm._v(" "), _c('div', {
    staticClass: "attention text-left my-2"
  }, [_vm._v("事務局承認後に掲載となります。(通常中3営業日)")])], 2), _vm._v(" "), _c('p', {
    staticClass: "text-right mt-5"
  }, [_c('router-link', {
    attrs: {
      "to": "/mypage"
    }
  }, [_vm._v("マイページへのリンク")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "attention"
  }, [_vm._v("※")]), _vm._v("必須\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3de13566!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/event/ConfirmBase.vue
// module id = 329
// module chunks = 1